import Cookies from 'js-cookie';
import { createRestApiClient } from '..';
import {
  deleteNullKeys,
  getUserIsLoggedIn,
  getUserToken,
} from '../../Utils/helper';
import { getDropOffDataPayment } from '../../Utils/addressUtils';
import { encodeUTF } from '../../Utils/CartUtils';

export const getUserId = () => {
  if (Cookies.get('logoutUserId') && !getUserIsLoggedIn()) {
    return Cookies.get('logoutUserId');
  } else {
    if (Cookies.get('react_user_properties')) {
      return JSON.parse(Cookies.get('react_user_properties'))?.user_id;
    }
  }
};

const getPaymentDropOffData = (orderData) => {
  const address = Cookies.get('is_default')
    ? JSON.parse(Cookies.get('is_default'))
    : {};
  const cartItems = Cookies.get('cart_items') || '';
  const fieldAddressEncrypted = getDropOffDataPayment(address);
  const coupon = Cookies.get('coupon_code') || null;
  const dropOffObject = {
    sku_ids: cartItems,
    coupon: coupon,
    key: fieldAddressEncrypted.join('.'),
  };
  deleteNullKeys(dropOffObject);
  let key = Object.keys(dropOffObject).map(
    (obj) => `${obj}=${dropOffObject[obj]}`,
  );
  key = key?.join('&');
  const user_id = getUserId();
  const term_id = orderData?.offer_id;
  const sku_ids = cartItems?.split(',');

  let finalObject = sku_ids?.map((sku) => {
    return {
      termId: term_id,
      productId: parseInt(sku),
      key: key,
      userId: parseInt(user_id),
    };
  });
  deleteNullKeys(finalObject);
  return finalObject;
};

export const handlePaymentDropOff = async (orderData) => {
  const dropOffData = getPaymentDropOffData(orderData);
  const restApiClient = createRestApiClient();
  const data = await restApiClient
    .request({
      method: 'POST',
      url: '/api/logUserEventData',
      headers: {
        authorization: getUserToken(),
      },
      params: { eventName: 'payment_drop_off', platform: 'web' },
      data: { eventData: dropOffData },
    })
    .then((res) => res.data?.data);
  return data;
};
export const handlePaymentDropOffGokwik = async (cart_id) => {
  const cartId = encodeUTF(cart_id);
  const user_id = getUserId();
  const offer_term_id = Cookies.get('offer_term_id') || null;
  let finalArray = [];
  let finalObject = {
    key: cartId,
    userId: parseInt(user_id),
    termId: offer_term_id,
  };
  finalArray.push(finalObject);
  const restApiClient = createRestApiClient();
  const data = await restApiClient
    .request({
      method: 'POST',
      url: '/api/logUserEventData',
      headers: {
        authorization: getUserToken(),
      },
      params: { eventName: 'payment_drop_off', platform: 'web' },
      data: { eventData: finalArray },
    })
    .then((res) => res.data?.data);
  return data;
};
